export { default as Img200 } from './processed/200/Killing-Of-A-Sacred-Deer-The.jpg';
export { default as Img400 } from './processed/400/Killing-Of-A-Sacred-Deer-The.jpg';
export { default as Imgthumb } from './processed/thumb/Killing-Of-A-Sacred-Deer-The.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Killing-Of-A-Sacred-Deer-The.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Killing-Of-A-Sacred-Deer-The.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      200,
      85,
      71
    ],
    "_population": 16,
    "_hsl": [
      0.018087855297157614,
      0.5397489539748953,
      0.5313725490196078
    ]
  },
  "LightVibrant": {
    "_rgb": [
      164,
      192,
      214
    ],
    "_population": 138,
    "_hsl": [
      0.5733333333333334,
      0.37878787878787884,
      0.7411764705882353
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      122,
      73,
      49
    ],
    "_population": 1852,
    "_hsl": [
      0.054794520547945195,
      0.42690058479532156,
      0.33529411764705885
    ]
  },
  "Muted": {
    "_rgb": [
      168,
      114,
      78
    ],
    "_population": 1043,
    "_hsl": [
      0.06666666666666667,
      0.3658536585365853,
      0.4823529411764706
    ]
  },
  "LightMuted": {
    "_rgb": [
      180,
      196,
      196
    ],
    "_population": 15057,
    "_hsl": [
      0.5,
      0.11940298507462686,
      0.7372549019607844
    ]
  },
  "DarkMuted": {
    "_rgb": [
      50,
      79,
      98
    ],
    "_population": 113,
    "_hsl": [
      0.5659722222222222,
      0.32432432432432434,
      0.2901960784313726
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Killing-Of-A-Sacred-Deer-The.js